/* eslint-disable no-unused-vars */
import _ from 'lodash';
import { Link, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import React, { useEffect, useRef, useState, useMemo, useLayoutEffect } from 'react';
import { store } from 'redux/store';

import VirtualList from '@components/virtual-list/virtual-list';
import SiteListingInner from '@components/site-listing-inner';
import Icon from '@components/icon-component';
import LoadingRound from '@components/loading-round/loading-round';
import Button from '@components/button/button.component';
import Badge from '@components/badge/badge';
import SiteFilter from './site-filter.component';

import VirtualListInModal from '@components/virtual-list-in-modal';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { tagsDataList, getSiteFilterDefaultValues } from './helper';
import useQuery from '@hooks/useQuery';
import { useDebounce } from '@hooks/useDebounce';
import { getAppDispatch } from '@utilities/dispatch.util';
import { backHistoryActions } from '@redux/slices/back-history';
import { initWebWorker } from 'webworker';

import { cacheActions } from '@redux/slices/cache';
import useLocation from '@hooks/useLocation';

import style from './style.module.scss';
import GoogleMap from '@components/google-map';
import FilterSortBar from './filter-sort-bar';
import { siteMapActions } from '@redux/slices/site-map';
import { getCountOnEachFilterObject } from '@utilities/dynamic-filter-list';
import { checkIfTheLocationIsNeedToUpdateOrNot } from '@utilities/date-filters';
import PullToRefresh from '@components/pull-to-refresh';
import Tags from '@components/tags';

const SiteListing = ({
  assetDetailsSiteLists = false,
  isFilterActiveHeader = false,
  setFilterActiveHeader = null,
  from,
  siteId = null,
  detailPage = false,
  detailsPageBookmarks = true,
  navLabel = 'Site',
  card: Card = () => <></>
}) => {
  const locationPermissionIsOn = useLocation();
  const dispatch = getAppDispatch();
  const isSet = useRef(null);
  const query = useQuery();
  const [searchParams] = useSearchParams();
  const bookmarkFilter = detailsPageBookmarks ? searchParams.get('bookmarkFilter') : null;
  const isMapView = searchParams.get('map-view')
    ? true
    : searchParams.get('showMapView') === 'true'
    ? true
    : false;
  const bookmarkName = searchParams.get('bookmarkName');
  const bookmarkSelectedSiteIdForMapView = searchParams.get('selectedSiteIdForMapView');
  const refetchSitesLocation = searchParams.get('RefetchSitesLocation');

  const dataFetchedRef = useRef(false);
  const { width, height } = useWindowDimensions();
  const [searched, setSearched] = useState('');
  const [filtersCount, setFiltersCount] = useState(0);
  const [resetFilters, setResetFilters] = useState(false);
  const [SelectedFilter, setSelectedFilter] = useState(['# TASKS']);
  const [isFilterActive, setFilterActive] = useState(width < 768 ? false : true);
  const [filters, setFilters] = useState(getSiteFilterDefaultValues);
  const [loading, setLoading] = useState(true);
  const [loadingOnSearch, setLoadingOnSearch] = useState(true);
  const [sites, setSites] = useState([]);
  const [sitesAreaHierarchyTreeDataMap, setSitesAreaHierarchyTreeDataMap] = useState({});
  const [sitesSiteTypeDataMap, setSitesSiteTypeDataMap] = useState({});
  const [sitesSiteStatusDataMap, setSitesSiteStatusDataMap] = useState({});
  const [sitesWorkOrderPriorityDataMap, setSitesWorkOrderPriorityDataMap] = useState({});
  const [isHidden, setIsHidden] = useState(false);
  const [filterSitesList, setFilterSitesList] = useState([]);
  const [siteCoordinateList, siteSiteCoordinateList] = useState([]);
  const [equipmentsEquipmentCategoryDataMap, setEquipmentsEquipmentCategoryDataMap] = useState({});
  const [equipmentsEquipmentTypeDataMap, setEquipmentsEquipmentTypeDataMap] = useState({});

  const { showMapView = false, selectedSiteIdForMapView } =
    useSelector((state) => state.siteMap) || {};
  const { coordinates, unit, locationUpdateTime } = useSelector((state) => state.cache);
  const { areaHierarchyTreeDataMap = {} } = useSelector((state) => state.picklists);

  const siteTypeQuery = query.get('type') || '';
  const siteFilterType = query.get('filterType') || '';
  const templateString = query.get('templates') || '';
  const runsString = query.get('runs') || '';

  const templates = useMemo(() => templateString.split(',').filter((el) => el), [templateString]);
  const runs = useMemo(() => runsString?.split(',').filter((el) => el), [runsString]);

  useEffect(() => {
    dispatch?.(siteMapActions.resetMapState());
  }, [dispatch]);

  useEffect(() => {
    if (isMapView && locationPermissionIsOn)
      setLoadingEvent({
        value: true,
        bookmarkSelectedSiteId: bookmarkSelectedSiteIdForMapView
          ? JSON.parse(bookmarkSelectedSiteIdForMapView)
          : null
      });
  }, [isMapView, bookmarkSelectedSiteIdForMapView, locationPermissionIsOn]);

  useEffect(() => {
    dispatch?.(backHistoryActions.clearAllDetailsPage(null));

    if (assetDetailsSiteLists?.length > 0) {
      setSites(assetDetailsSiteLists);
      setLoading(false);
    } else {
      checkIfTheLocationIsNeedToUpdateOrNot({
        addNewCoordinates: locationUpdateTime ? false : true,
        isOnline: navigator.onLine,
        unit,
        locationUpdateTime,
        oldCoordinates: coordinates,
        functionCall: getAllSiteListingFromSelector,
        loadingFunctionCall: () => {
          // setLoadingOnSearch(true);
        },
        params: {
          coordinates
        }
      });
    }
  }, [
    dispatch,
    assetDetailsSiteLists,
    showMapView,
    navigator.onLine,
    isMapView,
    locationUpdateTime,
    coordinates
  ]);

  const dynamicFilterCountOnEachField = useMemo(() => {
    const count = getCountOnEachFilterObject({ filtersCount, filters });
    return count;
  }, [filters, filtersCount]);

  const getAllSiteListingFromSelector = () => {
    initWebWorker({
      args: {
        store: { ...store.getState() },
        showMapView: showMapView || isMapView ? true : false,
        oldSiteList: (showMapView || isMapView) && sites?.length > 0 ? sites : [],
        siteTypeQuery
      },
      type: 'get-all-site-listings'
    })
      .then((data) => {
        setSites(data?.result);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setFilterActiveHeader && setFilterActiveHeader(isFilterActive);
  }, [isFilterActive]);

  useEffect(() => {
    assetDetailsSiteLists && setFilterActive(isFilterActiveHeader);
  }, [isFilterActiveHeader]);

  useEffect(() => {
    if (
      !isSet.current &&
      locationPermissionIsOn &&
      navigator.onLine &&
      SelectedFilter.includes('# TASKS')
    ) {
      setSelectedFilter(['DISTANCE']);
      isSet.current = true;
    }
  }, [locationPermissionIsOn, SelectedFilter, navigator.onLine]);

  useEffect(() => {
    if (!_.isEmpty(bookmarkFilter)) {
      const filtersInDecode = decodeURIComponent(bookmarkFilter);
      const filterInParse = JSON.parse(filtersInDecode);
      filterInParse?.filters && setFilters(filterInParse?.filters);
      filterInParse?.filters &&
        filterInParse?.filters['searched'] &&
        setSearched(filterInParse?.filters['searched'] || '');
      if (!_.isEmpty(filterInParse?.sort)) {
        const key = Object.keys(filterInParse?.sort)[0];
        setSelectedFilter(
          key === 'Tasks' || key === 'TASKS'
            ? ['# TASKS']
            : Object.keys(filterInParse?.sort) || '# TASKS'
        );
      }
    }
    return () => {};
  }, [bookmarkFilter]);

  useEffect(() => {
    SelectedFilter.length === 0 && setSelectedFilter(['A-Z']);
  }, [SelectedFilter]);

  const debouncedSearchInputValue = useDebounce(searched, 1000);

  useEffect(() => {
    if (!loading) {
      !loadingOnSearch && sites?.length > 0 && !refetchSitesLocation && setLoadingOnSearch(true);

      initWebWorker({
        args: {
          store: { ...store.getState() },
          filters: { ...filters, searched: debouncedSearchInputValue?.trim() },
          sites: sites,
          SelectedFilter,
          areaHierarchyTreeDataMap,
          siteTypeQuery,
          templates,
          runs,
          createCoordinateList: showMapView,
          selectedSiteIdForMapView
        },
        type: 'get-searched-sites-listing'
      })
        .then((data) => {
          const {
            filtered,
            sitesSiteTypeData,
            sitesSiteStatusData,
            sitesAreaHierarchyTreeData,
            sitesWorkOrderPriorityDataMap,
            allSiteCoordinatesList,
            equipmentsEquipmentCategoryData = {},
            equipmentsEquipmentTypeData = {}
          } = data?.result || {};

          setSitesWorkOrderPriorityDataMap(sitesWorkOrderPriorityDataMap || {});
          setSitesSiteTypeDataMap(sitesSiteTypeData || {});
          setSitesSiteStatusDataMap(sitesSiteStatusData || {});
          setSitesAreaHierarchyTreeDataMap(sitesAreaHierarchyTreeData || {});
          setFilterSitesList([...filtered]);
          siteSiteCoordinateList(allSiteCoordinatesList);
          setEquipmentsEquipmentTypeDataMap(equipmentsEquipmentTypeData || {});
          setEquipmentsEquipmentCategoryDataMap(equipmentsEquipmentCategoryData || {});

          setLoadingOnSearch(false);
        })
        .catch((error) => {
          setLoadingOnSearch(false);
        });
    }
  }, [
    filters,
    debouncedSearchInputValue,
    SelectedFilter,
    // isFilterActive,
    width,
    siteTypeQuery,
    templates,
    sites,
    loading,
    runs
    // selectedSiteIdForMapView.siteId
  ]);

  useEffect(() => {
    if (detailPage && filterSitesList)
      document.getElementById('assets-counts-in-nav-tabs-site').innerText = `${navLabel} (${
        filterSitesList?.length?.toLocaleString() || 0
      })`;
  }, [filterSitesList, detailPage, navLabel]);

  const tagsData = tagsDataList.filter((el) => {
    if (el === 'DISTANCE' && (!locationPermissionIsOn || !navigator.onLine)) return false;
    return true;
  });

  const resetFilter = () => {
    return (
      <div className="no-result">
        <div>No results.</div>

        {filtersCount > 0 && (
          <Button
            variant="border"
            onClick={() => setResetFilters((prev) => !prev)}
            text="Reset filters"
            btnClass="taskBtnClass"
          />
        )}
      </div>
    );
  };

  const handleWheel = (e) => {
    const virtualList = document?.querySelector('.cstmScrollerRef')?.scrollTop;

    if (e.deltaY > 0 && !isHidden) {
      setIsHidden(true);
    } else if (e.deltaY < 0 && virtualList === 0 && isHidden) {
      setIsHidden(false);
    }
  };

  let startY;

  const handleScroll = (e) => {
    const virtualList = document?.querySelector('.cstmScrollerRef')?.scrollTop;

    const deltaY = e.touches[0].clientY - startY;

    if (deltaY < 0 && !isHidden) {
      setIsHidden(true);
    } else if (deltaY > 0 && virtualList === 0 && isHidden) {
      setIsHidden(false);
    }
  };

  const handleTouchStart = (e) => {
    startY = e.touches[0].clientY;
  };

  const equipmentListingScrollEvent = (e) => {
    const assetDetailsNavigation = document.getElementById('assetDetailsNavigation');
    const siteDetailsPage = document.querySelector('#assetDetailPage');
    const currentTab = parseInt(searchParams.get('virtualScrollTab') || 0);
    const virtualListScroll = document?.querySelectorAll('.cstmScrollerRef')[currentTab];

    // if (virtualListScroll?.scrollTop === 0 && siteDetailsPage) {
    //   siteDetailsPage.scrollTop = 0;
    //   assetDetailsNavigation.classList.remove('assetDetailNavFixed');
    //   assetDetailsNavigation.classList.add('assetDetailNavNotFixed');
    // }
    if (assetDetailsNavigation.classList.value.includes('assetDetailNavNotFixed')) {
      if (virtualListScroll) {
        virtualListScroll.classList.remove('virtualListOverflowOverlay');
        virtualListScroll.classList.add('virtualListOverflowOverlay');
      }
    } else if (virtualListScroll) {
      virtualListScroll.classList.remove('virtualListOverflowOverlay');
      virtualListScroll.classList.add('virtualListOverflowOverlay');
    }
  };

  const siteListInSmallScreen = useMemo(() => {
    return width < 1025 && showMapView && !detailPage;
  }, [width, showMapView, detailPage]);

  const setLoadingEvent = ({ value, bookmarkSelectedSiteId = null }) => {
    dispatch?.(siteMapActions.setShowMapView(value));
    bookmarkSelectedSiteId &&
      dispatch?.(siteMapActions.setSelectedSiteIdOnMapView(bookmarkSelectedSiteId));
    setLoadingOnSearch(true);
    setLoading(true);
  };

  const moveSelectedSiteToTopOnMapView = useMemo(() => {
    if (selectedSiteIdForMapView?.siteId) {
      const filterSelectedSiteIndex = filterSitesList[selectedSiteIdForMapView.siteIndex]
        ? [filterSitesList[selectedSiteIdForMapView.siteIndex]]
        : [];

      let arr = selectedSiteIdForMapView?.siteId
        ? [
            ...filterSelectedSiteIndex,
            ...filterSitesList.filter((i) => i.siteId !== selectedSiteIdForMapView.siteId)
          ]
        : filterSitesList;

      setTimeout(() => {
        const virtualListModalContainer1 = document.getElementById('react-swipeable-virtual-list');
        if (virtualListModalContainer1) {
          virtualListModalContainer1.scrollTo(0, 0);
          virtualListModalContainer1.scrollIntoView({ behavior: 'smooth' });
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      }, 500);

      return arr;
    }
    return filterSitesList;
  }, [selectedSiteIdForMapView?.siteId, filterSitesList]);

  const sitesLists = () => {
    return (
      <>
        <div
          className="App"
          onWheel={handleWheel}
          onTouchStart={handleTouchStart}
          onTouchMove={handleScroll}
          style={{ height: '100%', position: 'relative' }}
        >
          {/* not show this filter bar on small screen on child details page */}
          {detailPage && width <= 768 ? (
            <></>
          ) : (
            <FilterSortBar
              isHidden={isHidden}
              loadingOnSearch={loadingOnSearch}
              isFilterActive={isFilterActive}
              filtersCount={filtersCount}
              tagsData={tagsData}
              selectedFilter={SelectedFilter}
              showMapView={showMapView}
              setSelectedFilterEvent={setSelectedFilter}
              setFilterActiveEvent={() => setFilterActive(true)}
              setLoadingEvent={setLoadingEvent}
              detailPage={detailPage}
              showEnableLocationNotificationOnMapBookmark={
                !loadingOnSearch && !locationPermissionIsOn && isMapView ? true : false
              }
            />
          )}

          {loadingOnSearch ? (
            <div
              style={{
                backgroundColor: 'transparent',
                width: '100%',
                marginTop: showMapView ? '69px' : '0px'
              }}
            >
              <LoadingRound />
            </div>
          ) : (
            <>
              <PullToRefresh noPullToDownRefresh={detailPage ? true : showMapView}>
                <div
                  className={`${style.mapAndListContainer} ${
                    showMapView && style.mapAndListContainerOnShowMapView
                  }`}
                >
                  {/* Desktop And Tablet Screen */}
                  {width > 1025 || (width < 1025 && !showMapView) ? (
                    <div className={`${style.list} ${showMapView && style.isMapView}`}>
                      <VirtualList
                        data={moveSelectedSiteToTopOnMapView}
                        divider={true}
                        siteListingPage
                        content={detailPage && width <= 768 ? FIlterTags : () => <></>}
                        component={SiteListingInner}
                        onScrollEvent={assetDetailsSiteLists ? equipmentListingScrollEvent : null}
                        isHidden={isHidden}
                        componentProps={{
                          highlight: searched,
                          highlightName: true,
                          from,
                          noLink: true
                        }}
                      />
                    </div>
                  ) : (
                    <></>
                  )}

                  {showMapView && (
                    <div className={style.googleMapContainer}>
                      <GoogleMap
                        siteCoordinateList={siteCoordinateList}
                        open={siteListInSmallScreen}
                        list={moveSelectedSiteToTopOnMapView}
                      />
                    </div>
                  )}
                </div>
              </PullToRefresh>
            </>
          )}
        </div>
      </>
    );
  };

  const listingPageContainer = document.getElementById('site-listing-pages-container');

  useLayoutEffect(() => {
    if (detailPage && listingPageContainer && width <= 768) {
      const topHeaderHeight = 86;
      const navigationTabsHeight = 32 + 16;
      const bottomFooterHeight = 84;

      const totalHeight = topHeaderHeight + bottomFooterHeight + navigationTabsHeight;

      listingPageContainer.style.height = `calc(100dvh  - ${totalHeight}px)`;
    }
  }, [detailPage, width, listingPageContainer]);

  const FIlterTags = () => {
    return (
      <>
        {Card ? <Card /> : <></>}

        <div
          className={`op-filter-sort`}
          style={{
            borderBottom: loadingOnSearch ? 'none ' : '1px solid rgb(229, 229, 229)',
            padding: '18px'
          }}
        >
          <div>
            <div className={`btn-sort-wrap ${isFilterActive ? '' : 'btn-sort-wrap-list'}`}>
              <Tags tags={tagsData} value={SelectedFilter} onChange={setSelectedFilter} />
            </div>
          </div>
        </div>
      </>
    );
  };

  const headerTitle = React.useMemo(() => {
    return siteTypeQuery &&
      ['Check', 'Inspection', 'Work Order', 'Work Request', 'hseEvents', 'NewOrEditAsset'].includes(
        siteTypeQuery
      )
      ? `${
          siteTypeQuery === 'Inspection'
            ? 'Inspections'
            : siteTypeQuery === 'Work Order'
            ? 'Work orders'
            : siteTypeQuery === 'Check'
            ? 'Checks'
            : siteTypeQuery === 'Work Request'
            ? 'Work requests'
            : siteTypeQuery === 'hseEvents'
            ? 'HSE events'
            : siteTypeQuery === 'NewOrEditAsset'
            ? 'New or edited'
            : siteTypeQuery
        } by site (${filterSitesList.length.toLocaleString()})`
      : `Sites (${filterSitesList.length.toLocaleString()})`;
  }, [filterSitesList, siteTypeQuery]);

  const siteFilterGroups = () => {
    return (
      <SiteFilter
        sites={sites || []}
        onSearch={setSearched}
        length={filterSitesList.length}
        resetFilters={resetFilters}
        setResetFilters={setResetFilters}
        filtersCount={filtersCount}
        onChangeFilters={setFilters}
        isFilterActive={isFilterActive}
        setFiltersCount={setFiltersCount}
        setFilterActive={setFilterActive}
        sitesSiteTypeDataMap={sitesSiteTypeDataMap}
        sitesSiteStatusDataMap={sitesSiteStatusDataMap}
        sitesWorkOrderPriorityDataMap={sitesWorkOrderPriorityDataMap}
        sitesAreaHierarchyTreeDataMap={sitesAreaHierarchyTreeDataMap}
        selectedSort={SelectedFilter}
        bookmarkFilter={bookmarkFilter}
        filterType={siteFilterType}
        removeClassOnAssetDetailsFilters={assetDetailsSiteLists}
        siteId={siteId}
        detailPage={detailPage}
        dynamicFilterCountOnEachField={dynamicFilterCountOnEachField}
        locationPermissionIsOn={locationPermissionIsOn}
        equipmentsEquipmentCategoryDataMap={equipmentsEquipmentCategoryDataMap}
        equipmentsEquipmentTypeDataMap={equipmentsEquipmentTypeDataMap}
      />
    );
  };
  const siteFilterGroupsForAssetDetailsPage = () => {
    return siteFilterGroups();
  };

  return (
    <div className="relative overflow-x-hidden">
      {!assetDetailsSiteLists && (
        <div
          className="op-page-name op-listing-name px-4 md:px-8 py-7 flex flex-wrap justify-between items-center relative"
          style={{
            position: 'sticky',
            top: 0
          }}
        >
          <Link className="op-back " to={-1}></Link>
          <h1 className="h1-semibold pl-16" id="site-header-listing">
            {!_.isEmpty(bookmarkName) ? bookmarkName : <>{headerTitle}</>}
          </h1>
          <button className="filter-btn" onClick={() => setFilterActive(true)}>
            <Badge size="small" count={filtersCount} color="#ffffff" textColor={'#2f80ed'}>
              <Icon name={'filter'} color={'#ffffff'} width="20px" height="18px" />
            </Badge>
          </button>
        </div>
      )}

      <div
        className="flex"
        style={{
          height: 'calc(100svh - 94px)',
          overflowY: 'auto'
        }}
        id="assetDetailsWorkOrderAndInspections"
      >
        {siteFilterGroupsForAssetDetailsPage()}
        <div>
          {!detailPage && siteListInSmallScreen && (
            <VirtualListInModal
              open={siteListInSmallScreen}
              list={moveSelectedSiteToTopOnMapView}
              assetDetailsSiteLists={assetDetailsSiteLists}
              equipmentListingScrollEvent={equipmentListingScrollEvent}
              isHidden={isHidden}
              searched={searched}
              from={from}
              selectedSiteIdForMapView={selectedSiteIdForMapView}
              height={height}
              width={width}
              isFilterActive={isFilterActive}
              openMenuTabIsActive={searchParams.get('openMenuTabIsActive') || false}
            />
          )}
        </div>
        <div
          className={`${
            detailPage ? style['page-listingForAssetDetails'] : style['page-listing']
          }  ${style.paddingClass} ${filterSitesList.length > 0 ? 'no-appbar' : ''}
          ${filterSitesList.length > 0 ? style.marginNo : style.marginYes}
            `}
          style={{
            borderLeft: isFilterActive ? '0.5px solid #cbd2d9' : 'none',
            paddingBottom: '0px',
            flex: 1,
            overflow: 'hidden'
          }}
          id="site-listing-pages-container"
        >
          {filterSitesList.length === 0 && loadingOnSearch === false ? resetFilter() : sitesLists()}
        </div>
        <div style={{ height: '80px' }}></div>
      </div>
    </div>
  );
};

export default React.memo(SiteListing, _.isEqual);
